(ns ycweb.app.website.school.module.notes
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc module-detail < rum/reactive [app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        item (cmn/curact state-atom [:item])
        output (cmn/curact state-atom [:output])
        {:item/keys [lesson-header lesson-ingredients lesson-notes]} item
        {:ent/keys [uuid display-name image]} item]
    [:main
     {:id "main-content" :class (u/bem :yc-page-content [:standard])}

     (when-not (= output "pdf")
       [:nav
        {:class (u/bem :yc-section [:standard])}
        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:t-2-3])}
          [:div.flex-grid-content.u-text-right
           (buttons/button-web
             ["Download" [:span.clip-text.unclip-text--m " PDF"]]
             {:href (str "/api/school/note/generate/" uuid ".pdf")
              :target "_blank"
              :style :primary
              :size :small})]]]])

     [:div.course-notes
      [:header
       {:class (u/bem :yc-section [:standard] :course-notes__header)}
       [:div.print-only.delete-no
        [:div.course-notes__logo
         [:i {:class (u/bem :icon [:yc-icon :inline])}]]
        [:h1.course-notes__title display-name]
        [:span {:dangerouslySetInnerHTML {:__html lesson-header}}]]]

      [:div
       {:class (u/bem :yc-section [:standard] :course-notes__banner :print-only)}
       [:img.pf-large-image
        {:src
         (u/cloudinary (:doc/public-id image)
           {:q "auto" :f "auto" :c "lpad" :effect "sharpen:40"})}]]

      [:div
       {:class (u/bem :yc-section [:standard] :course-notes__content :print-only)}
       (cond
         (not-empty lesson-ingredients)
         [:div.flex-grid-group
          [:div
           {:class (u/bem :flex-grid-block [:ml-1-3])}
           [:div.flex-grid-content.course-notes__sidebar
            {:dangerouslySetInnerHTML {:__html lesson-ingredients}}]]
          [:div
           {:class (u/bem :flex-grid-block [:ml-2-3])}
           [:div.flex-grid-content.course-notes__details
            {:dangerouslySetInnerHTML {:__html lesson-notes}}]
           [:div.course-notes__signature-logo.delete-no
            [:img
             {:src (u/cloudinary "pages/cooking-school/course-notes/yuppiechef-logo.png" {})
              :width 240
              :height 40
              :alt "Yuppiechef logo"}]]
           [:small.course-notes__signature-text.delete-no
            "Learn to cook online at "
            [:a {:href "/cooking-school.htm"}
             "www.yuppiechef.com/cooking-school.htm"]]]]

         :else
         (list
           [:div
            {:dangerouslySetInnerHTML {:__html lesson-notes}}]
           [:div.course-notes__signature-logo.delete-no.u-block-center
            [:img
             {:src (u/cloudinary "ui-resources/shared/yuppiechef-official-logo.png" {})
              :width 240
              :height 93
              :alt "Yuppiechef logo"}]]
           [:small.course-notes__signature-text.delete-no
            "Learn to cook online at "
            [:a {:href "/cooking-school.htm"}
             "www.yuppiechef.com/cooking-school.htm"]]))]]

     (when-not (= output "pdf")
       [:nav
        {:class (u/bem :yc-section [:large])}
        [:div.flex-grid-group
         [:div
          {:class (u/bem :flex-grid-block [:t-2-3])}
          [:div.flex-grid-content.u-text-right
           (buttons/button-web
             ["Download" [:span.clip-text.unclip-text--m " PDF"]]
             {:href (str "/api/school/note/generate/" uuid ".pdf")
              :target "_blank"
              :style :primary
              :size :small})]]]])]))

(defmethod flow/render-screen :web.cooking-school/moduledetail [app-atom _]
  (module-detail app-atom))

(defmethod t/transition-open :web.cooking-school/moduledetail [app-atom _ params]
  (let [state-atom (cmn/action-cursor app-atom)]
    (swap! state-atom assoc :output (:output params) :item nil)
    (comms/ajax-get :web.cooking-school/moduledetail {:ent/uuid (:uuid params)})))

(defmethod comms/receive :web.cooking-school/moduledetail [app-atom e]
  (swap!
    (cmn/action-cursor app-atom) assoc
    :item (:item e)))
